import {
  ADD_RAISE_TICKET,
  GET_RAISETICKET_DETAIL,
  GET_RAISETICKET_LIST,
  GET_RAISETICKET_USER_LIST,
  REPLY_SUPPORT_TICKET,
  UPDATE_RAISE_TICKET,
  UPDATE_RAISE_TICKET_STATUS,
} from "../types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import raiseTicketSerive from "reduxStore/service/raiseTicket(Support)Serivce";

export const getRaiseTicketList = (item) => async (dispatch) => {
  try {
    const res = await raiseTicketSerive.getRaiseTicketList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_RAISETICKET_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_RAISETICKET_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getRaiseTicketDetail = (item) => async (dispatch) => {
  try {
    const res = await raiseTicketSerive.getRaiseTicketDetail(item);

    if (res.data.status === 200) {
      dispatch({
        type: GET_RAISETICKET_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const updateRaiseTicketStatus = (item) => async (dispatch) => {
  try {
    const res = await raiseTicketSerive.updateRaiseTicket(item);
    if (res.data.status === 200) {
      dispatch({
        type: UPDATE_RAISE_TICKET_STATUS,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const updateRaiseTicket = (item) => async (dispatch) => {
  try {
    const res = await raiseTicketSerive.updateRaiseTicket(item);
    if (res.data.status === 200) {
      dispatch({
        type: UPDATE_RAISE_TICKET,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const replySupportTicket = (item) => async (dispatch) => {
  try {
    const res = await raiseTicketSerive.replySupportTicket(item);
    if (res.data.status === 200) {
      dispatch({
        type: REPLY_SUPPORT_TICKET,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const replySupportTicketRemove = (item) => async (dispatch) => {
  try {
    dispatch({
      type: REPLY_SUPPORT_TICKET,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const addRaiseTicket = (item) => async (dispatch) => {
  try {
    const res = await raiseTicketSerive.addRaiseTicket(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_RAISE_TICKET,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
